<template>
<span>
There is a gap between the {{warning.warningType}} start date
<span class='error--text'>({{warning.dateFrom}})</span>
and the previous {{warning.warningType}} end date
<span class='error--text'>({{warning.dateTo}})</span>.
</span>
</template>
<script lang="ts">
import Vue from 'vue';
import { GapWarningInfo, IGapWarningConfig } from '@/api/gapwarning';
import {
  Component, Prop,
} from 'vue-property-decorator';

@Component
export default class GapWarning extends Vue {
    @Prop()
    warning!:IGapWarningConfig;
}
</script>
<style lang="scss" scoped>
</style>
